import { ApiResponse, DataWithPagination } from '@/shared/types';
import { WorkflowBaseInfo, WorkflowModel } from '../domain';
import {
  AssociateTaskToWorkflow,
  CreateWorkflowJson,
  OrderWorkflow,
  UpdateWorkflowDto,
} from '../types';

export abstract class WorkflowRepository {
  abstract createWorkflow(data: CreateWorkflowJson): Promise<void>;
  abstract getWorkflow(id: number): Promise<WorkflowModel>;
  abstract enableWorkflow(id: number): Promise<ApiResponse<unknown>>;
  abstract disableWorkflow(id: number): Promise<ApiResponse<unknown>>;
  abstract orderWorkflow(data: OrderWorkflow): Promise<ApiResponse<unknown>>;
  abstract deleteWorkflow(id: number): Promise<ApiResponse<unknown>>;
  abstract updateWorkflow(data: UpdateWorkflowDto): Promise<unknown>;
  abstract getWorkflowsByBusinessAreaId(
    businessAreaId: number,
  ): Promise<WorkflowBaseInfo[]>;
  abstract getWorkflowsByBusinessArea(
    businessAreaId: number,
    pageNumber?: number,
    filter?: string,
  ): Promise<DataWithPagination<WorkflowModel[]>>;
  abstract getWorkflowsByOrganization(
    organizationId: number,
    pageNumber?: number,
    filter?: string,
  ): Promise<DataWithPagination<WorkflowModel[]>>;
  abstract getWorkflowsTasksByProcessId(
    processId: number,
  ): Promise<WorkflowModel[]>;
  abstract getWorkflowsByCompany(
    companyId: number,
    pageNumber?: number,
    filter?: string,
  ): Promise<DataWithPagination<WorkflowModel[]>>;

  abstract associateTaskToWorkflow(
    data: AssociateTaskToWorkflow,
  ): Promise<ApiResponse<unknown>>;
}
